import React from 'react';
import './generic-modal.scss';
import { Modal } from 'antd';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import { TooltipDisableReason } from '../tooltip-disable-message/tooltip-disable-reason';

interface ActionButtonProps {
    text: string;
    onClick: () => void;
    className: string;
    disabled?: boolean;
    disableReason?: string
}

interface GenericModalProps {
    open?: boolean;
    title: string | React.ReactElement;
    subtitle?: string;
    body: React.ReactNode;
    icon?: React.ReactNode;
    actionButtons: ActionButtonProps[];
    onCancel?: () => void;
    wrapClassName?: string;
    width?: number;
    closable?: boolean;
    destroyOnClose?: boolean;
}

const GenericModal: React.FC<GenericModalProps> = ({ open, title, body, icon,
                                                       actionButtons, wrapClassName, onCancel,
                                                       width, closable= true, destroyOnClose = false, subtitle }) => {
    return (<Modal closeIcon={<CustomIcon type={IconType.X}/>}
                   maskClosable={false}
                   className={`generic-modal ${wrapClassName}`}
                   open={open}
                   footer={null}
                   width={width ?? 562}
                   onCancel={onCancel}
                   closable={closable}
                   centered
                   destroyOnClose={destroyOnClose}>
            <div className={`modal-wrapper`}>
                <div className="modal-header">
                    {icon && <div className="modal-icon">{icon}</div>}
                    <div className="ant-modal-confirm-title">{title}</div>
                    {subtitle && <div className="ant-modal-confirm-subtitle">{subtitle}</div>}
                </div>
                <div className="modal-body">
                    {body}
                </div>
                { actionButtons.length > 0 && <div className="modal-footer ant-modal-confirm-btns">
                    {actionButtons.map(actionButton => (
                        <TooltipDisableReason overlayClassName="disable-tooltip" key={actionButton.text}
                                              disableReason={actionButton.disableReason}>
                            <button className={`custom-btn ${actionButton.className} large-btn`} onClick={actionButton.onClick} disabled={actionButton.disabled}>
                                {actionButton.text}
                            </button>
                        </TooltipDisableReason>

                    ))}
                </div> }
            </div>
        </Modal>
    );
};

export default GenericModal;